import DropdownSelection from 'app/models/dropdown_selection';

export default DropdownSelection.extend({
  initialize({ mode }) {
    this.choices = [
      { option: 'production', readable: 'Production' },
      { option: 'test', readable: 'Test' },
    ];
    this.paramKey = 'mode';
    this.label = 'Environment';
    this.setCurrentChoice(mode);
  },
});



// WEBPACK FOOTER //
// ./app/models/api_mode_selection.js